import {
	AudienceModalComponent,
	type AudienceModalSection,
	useAudience,
	useCreateAudienceEffect,
} from "@di-devs/audience-feature-plugin/client";
import type { FC } from "react";
import EventAudienceFilters from "./EventAudienceFilters";

interface EventAudienceModalProps {
	visible: boolean;
	onClose: () => void;
}

const EventAudienceModal: FC<EventAudienceModalProps> = ({
	visible,
	onClose,
}) => {
	const {
		hooks: { createAudienceMutation, searchAudienceMutation },
	} = useAudience();

	// Define filter sections for the composer
	const filterSections: AudienceModalSection[] = [
		{
			key: "eventFilters",
			title: "イベントフィルター",
			content: <EventAudienceFilters />,
		},
	];

	// MARK: UI Effects
	useCreateAudienceEffect(createAudienceMutation, {
		onSuccess: onClose,
		onError: (error) => {
			console.error("Failed to create audience:", error);
		},
	});

	return (
		<AudienceModalComponent.Provider visible={visible} onClose={onClose}>
			<AudienceModalComponent.Composer sections={filterSections} />
			<AudienceModalComponent.Container
				width={{
					create: 600,
				}}
			>
				<AudienceModalComponent.Body>
					<AudienceModalComponent.Header />
					<AudienceModalComponent.Filters
						onFinish={(values) =>
							searchAudienceMutation.mutate({ ...values, type: "event" })
						}
					/>
					<AudienceModalComponent.Results
						count={searchAudienceMutation.data?.count || 0}
					/>
					<AudienceModalComponent.Actions
						onCreate={(values) =>
							createAudienceMutation.mutate({ ...values, type: "event" })
						}
						isLoading={createAudienceMutation.isPending}
						searchResults={searchAudienceMutation.data}
					/>
				</AudienceModalComponent.Body>
			</AudienceModalComponent.Container>
		</AudienceModalComponent.Provider>
	);
};

export default EventAudienceModal;
